function Section5() {
    return (
        <div>
            <div className="cls5">
                <h1>Topics recommended for you</h1>
                <div className="cls1">
                    <p>website</p>
                    <p>Javascript</p>
                    <p>CSS</p>
                    <p>React JS</p>
                    <p>GitHub</p>
                    <p>Docker</p>
                    <p>AWS</p>
                    <p>Azure</p>
                    <p>HTMl</p>
                </div>
            </div>
        </div>
    )
}

export default Section5